import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
} from "@mui/material";
import { MdDeleteOutline, MdOutlineLogout } from "react-icons/md";
import "./deleteModal.scss";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  variant?: "delete" | "logout";
  title?: string;
  description?: string;
  buttonText?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  variant = "delete",
  title,
  description,
  buttonText,
}) => {
  const config = {
    delete: {
      title: title || "Are you sure?",
      description: description || "Do you want to delete this item?",
      buttonText: buttonText || "Delete",
      icon: <MdDeleteOutline size={20} />,
      buttonColor: "error" as const,
    },
    logout: {
      title: title || "Are you sure?",
      description: description || "Do you want to logout?",
      buttonText: buttonText || "Logout",
      icon: <MdOutlineLogout size={20} />,
      buttonColor: "primary" as const,
    },
  }[variant];

  return (
    <Dialog open={open} onClose={onClose} className="confirm-dialog">
      <DialogContent>
        <div className="confirm-dialog-title">{config.title}</div>
        <div className="confirm-dialog-description">{config.description}</div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color={config.buttonColor}
          variant="contained"
          startIcon={config.icon}
        >
          {config.buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;